// core/data/feedTopics.ts — the 8 For-You topic keys, canonical order + labels.
//
// Mirrors the server's topic set — TOPICS in backend/apps/content/topics.py,
// which is the single source of truth. (That path used to read
// "backend/apps/posts", an app which does not exist; the mirror relationship
// was undocumented in practice, which is part of why the guard below was
// missing for so long.) feedTopics.sync.test.ts now pins both ends.
//
// This list is not only a fallback for a failed fetch: features/home/FeedTabs
// renders it STATICALLY for the Home For-You chips and never calls
// /api/users/topics/, so drift here is user-visible, not merely latent.
//
// 'general' is deliberately NOT a member — it always stays on and the server
// rejects it if sent.

export type FeedTopicKey =
  | 'news_politics'
  | 'technology'
  | 'gaming'
  | 'entertainment'
  | 'sports'
  | 'business_finance'
  | 'science_education'
  | 'lifestyle';

export interface FeedTopicOption {
  key: FeedTopicKey;
  label: string;
}

export const FEED_TOPICS: FeedTopicOption[] = [
  { key: 'news_politics', label: 'News & Politics' },
  { key: 'technology', label: 'Technology' },
  { key: 'gaming', label: 'Gaming' },
  { key: 'entertainment', label: 'Entertainment' },
  { key: 'sports', label: 'Sports' },
  { key: 'business_finance', label: 'Business & Finance' },
  { key: 'science_education', label: 'Science & Education' },
  { key: 'lifestyle', label: 'Lifestyle' },
];
